import moment from "moment-timezone";

export type RequestPaymentDisableInfo = {
  disabled: boolean;
  reason?: string;
  nextAllowedAt?: Date;
};

const DEFAULT_WINDOW_HOURS = 72;

const toPositiveNumberOrDefault = (value: any, defaultValue: number) => {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return defaultValue;
  return n;
};

export const getRequestPaymentDisableInfo = (
  shift: any,
  now: Date = new Date()
): RequestPaymentDisableInfo => {
  const remaining = shift?.remainingWorkerPaymentReminderCount;
  if (typeof remaining === "number" && remaining <= 0) {
    return {
      disabled: true,
      reason: "You have reached the maximum number of payment reminders for this shift.",
    };
  }

  const windowHoursRaw =
    shift?.pharmacy?.network?.workerPaymentReminderHourWindow ??
    shift?.network?.workerPaymentReminderHourWindow ??
    DEFAULT_WINDOW_HOURS;
  const windowHours = toPositiveNumberOrDefault(
    windowHoursRaw,
    DEFAULT_WINDOW_HOURS
  );

  const triggeredAt = shift?.workerPaymentReminderTriggeredAt;
  if (triggeredAt) {
    const triggered = moment(triggeredAt);
    if (triggered.isValid()) {
      const nextAllowed = triggered.clone().add(windowHours, "hours");
      if (moment(now).isBefore(nextAllowed)) {
        const tz = shift?.shiftTimeZone;
        let nextAllowedLabel = nextAllowed.format("MMM D, YYYY h:mm A");
        if (typeof tz === "string" && tz.trim().length > 0) {
          try {
            nextAllowedLabel = nextAllowed
              .clone()
              .tz(tz)
              .format("MMM D, YYYY h:mm A");
          } catch (_e) {
            // ignore timezone errors and fall back to local formatting
          }
        }

        return {
          disabled: true,
          reason: `You can request a payment reminder after ${nextAllowedLabel}.`,
          nextAllowedAt: nextAllowed.toDate(),
        };
      }
    }
  }

  return { disabled: false };
};
